__turbopack_context__.v({
  "bottomLink": "WPrezentationCards-module__FNnt3G__bottomLink",
  "cardThrowLeft": "WPrezentationCards-module__FNnt3G__cardThrowLeft",
  "cardThrowRight": "WPrezentationCards-module__FNnt3G__cardThrowRight",
  "cardsCarouselStage": "WPrezentationCards-module__FNnt3G__cardsCarouselStage",
  "cardsSlideHidden": "WPrezentationCards-module__FNnt3G__cardsSlideHidden",
  "cardsSlideItem": "WPrezentationCards-module__FNnt3G__cardsSlideItem",
  "cardsSlideLeavingLeft": "WPrezentationCards-module__FNnt3G__cardsSlideLeavingLeft",
  "cardsSlideLeavingRight": "WPrezentationCards-module__FNnt3G__cardsSlideLeavingRight",
  "cardsSlidePos0": "WPrezentationCards-module__FNnt3G__cardsSlidePos0",
  "cardsSlidePos1": "WPrezentationCards-module__FNnt3G__cardsSlidePos1",
  "cardsSlidePos2": "WPrezentationCards-module__FNnt3G__cardsSlidePos2",
  "cardsStage": "WPrezentationCards-module__FNnt3G__cardsStage",
  "cta": "WPrezentationCards-module__FNnt3G__cta",
  "empty": "WPrezentationCards-module__FNnt3G__empty",
  "kenBurns": "WPrezentationCards-module__FNnt3G__kenBurns",
  "media": "WPrezentationCards-module__FNnt3G__media",
  "overlay": "WPrezentationCards-module__FNnt3G__overlay",
  "root": "WPrezentationCards-module__FNnt3G__root",
  "slide": "WPrezentationCards-module__FNnt3G__slide",
  "slideLink": "WPrezentationCards-module__FNnt3G__slideLink",
  "subtitle": "WPrezentationCards-module__FNnt3G__subtitle",
  "subtitleItem": "WPrezentationCards-module__FNnt3G__subtitleItem",
  "tab": "WPrezentationCards-module__FNnt3G__tab",
  "tabActive": "WPrezentationCards-module__FNnt3G__tabActive",
  "tabFill": "WPrezentationCards-module__FNnt3G__tabFill",
  "tabFillGrow": "WPrezentationCards-module__FNnt3G__tabFillGrow",
  "tabTrack": "WPrezentationCards-module__FNnt3G__tabTrack",
  "tabs": "WPrezentationCards-module__FNnt3G__tabs",
  "title": "WPrezentationCards-module__FNnt3G__title",
});
